/**
 * Sample data for auto-fill on Leave Request create page.
 * Dates are computed relative to "today" so samples stay valid.
 * Applied to: startDate, endDate, reason. (User must still select employee and leave type.)
 */

export type LeaveRequestCreateFormSample = {
  startDate: string; // YYYY-MM-DD
  endDate: string;
  reason: string;
};

function formatDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

function addDays(d: Date, days: number): Date {
  const out = new Date(d);
  out.setDate(out.getDate() + days);
  return out;
}

/** Next weekday (skip weekend). */
function nextWeekday(d: Date): Date {
  const out = new Date(d);
  out.setDate(out.getDate() + 1);
  while (out.getDay() === 0 || out.getDay() === 6) {
    out.setDate(out.getDate() + 1);
  }
  return out;
}

/**
 * Returns samples with dates relative to today. Call when applying so dates are current.
 */
export function getLeaveRequestCreateFormSamples(): LeaveRequestCreateFormSample[] {
  const today = new Date();
  const tomorrow = addDays(today, 1);
  const startNextWeek = nextWeekday(addDays(today, 7));
  const endNextWeek = addDays(startNextWeek, 2);

  return [
    {
      startDate: formatDate(tomorrow),
      endDate: formatDate(tomorrow),
      reason: "ປ່ວຍ",
    },
    {
      startDate: formatDate(startNextWeek),
      endDate: formatDate(endNextWeek),
      reason: "ພັກພະຈົນ",
    },
    {
      startDate: formatDate(tomorrow),
      endDate: formatDate(addDays(tomorrow, 2)),
      reason: "ລາກິດ 3 ວັນ",
    },
    {
      startDate: formatDate(startNextWeek),
      endDate: formatDate(addDays(startNextWeek, 4)),
      reason: "ລາພັກຄອບຄົວ",
    },
  ];
}
